import {
  CTV_ALIAS_IDS,
  CTV_REGIONS,
  HOME_REGIONS_ALIAS_REGION_NAMES,
} from '~/shared/constants'

export const checkCtvLandingRegion = (region = ''): boolean => {
  return Object.keys(CTV_REGIONS).includes(
    region.toLowerCase() as keyof typeof CTV_REGIONS
  )
}

export const getEpgRegionFromAlias = (alias = ''): string => {
  const normalizedAlias = alias.toLowerCase() as keyof typeof CTV_ALIAS_IDS

  // Get the region ID from CTV_ALIAS_IDS
  const regionId = CTV_ALIAS_IDS[normalizedAlias]
  if (!regionId) return ''

  // Get the human-readable region name from HOME_REGIONS_ALIAS_REGION_NAMES
  const regionName = HOME_REGIONS_ALIAS_REGION_NAMES[normalizedAlias]
  if (!regionName) return ''

  // Convert region name to kebab-case (e.g., "Latin America" -> "latin-america")
  const kebabCaseName = regionName.toLowerCase().replace(/\s+/g, '-')

  // Return format: "latin-america-295", "africa-268", "arab-world-292"
  return `${kebabCaseName}-${regionId}`
}
